import { useContext } from 'react';
import { Controller } from 'react-hook-form';
import InputMask from 'react-input-mask';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';

import inputFieldSize from './inputFieldSize';
import { Context } from '../../Provider';
import InputRequired from '../../../common/InputRequired';

const PhoneNumberInputField = ({ control, errors, readOnly, hiddenTitel = false, customClass = "col-md-6" }) => {
    const { state } = useContext(Context);
    const { commonSettings } = state;

    return (
        <div className={`col-12 ${customClass}`}>
            <FormControl error={!!errors.ftm_contact_number} fullWidth>
                {!hiddenTitel && <strong>Phone number <InputRequired/></strong>}
                <Controller
                    name="ftm_contact_number"
                    control={control}
                    render={({ field }) => (
                        <InputMask
                            mask={commonSettings?.phone_number_format || "+44 799 999 9999"}
                            value={field.value || ''}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                        >
                            {(inputProps) => (
                                <TextField
                                    {...inputProps}
                                    inputRef={field.ref} // ✅ Proper ref forwarding
                                    placeholder="Phone number"
                                    size={inputFieldSize}
                                    error={!!errors.ftm_contact_number}
                                    InputProps={{
                                        readOnly: readOnly,
                                    }}
                                    sx={{
                                        '& .MuiInputBase-root': {
                                            backgroundColor: readOnly ? '#f5f5f5' : 'inherit',
                                        },
                                    }}
                                />
                            )}
                        </InputMask>
                    )}
                />
                {errors.ftm_contact_number && (
                    <FormHelperText>{errors.ftm_contact_number.message}</FormHelperText>
                )}
            </FormControl>
        </div>
    )

};

export default PhoneNumberInputField;